import { ReactNode, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useIdle } from "../../customHooks/useIdle";
import { getCookie } from "../../helperFunctions/cookies";
import { useAppSelector } from "../../redux/hooks";
import { CLIENT_COOKIE_KEY } from "../../utils/constants";

export const Protected = ({ children }: { children: ReactNode }) => {
  const navigate = useNavigate();

  const location = useLocation();

  const { isLoggedIn } = useAppSelector((state) => state.auth);

  useIdle();

  useEffect(() => {
    const token = getCookie(CLIENT_COOKIE_KEY);

    const isAuthenticated = !!token ? true : false;

    if (!isAuthenticated || !isLoggedIn) {
      navigate("/auth/sign-in");
    }
    // eslint-disable-next-line
  }, [location.pathname, isLoggedIn]);

  return <>{children}</>;
};
